var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intro-header'),_c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"intromain bg-white",style:(_vm.getBackgroundColor)},[_c(_vm.currentComponent,{tag:"component"})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }